import React, { Component } from "react";
import WidgetPageRenderer from "../widgets/WidgetPageRenderer";

export default class User_dashboard_configs_NEW extends Component {
  render() {
    return <WidgetPageRenderer pageRoute="user_dashboard_configs" />;
  }
}
